(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('model-meter', {
            parent: 'entity',
            url: '/model-meter?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.modelMeter.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/model-meter/model-meters.html',
                    controller: 'ModelMeterController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modelMeter');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('model-meter-detail', {
            parent: 'entity',
            url: '/model-meter/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.modelMeter.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/model-meter/model-meter-detail.html',
                    controller: 'ModelMeterDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modelMeter');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ModelMeter', function($stateParams, ModelMeter) {
                    return ModelMeter.get({id : $stateParams.id});
                }]
            }
        })
        .state('model-meter.new', {
            parent: 'model-meter',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/model-meter/model-meter-dialog.html',
                    controller: 'ModelMeterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('model-meter', null, { reload: true });
                }, function() {
                    $state.go('model-meter');
                });
            }]
        })
        .state('model-meter.edit', {
            parent: 'model-meter',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/model-meter/model-meter-dialog.html',
                    controller: 'ModelMeterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ModelMeter', function(ModelMeter) {
                            return ModelMeter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('model-meter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('model-meter.delete', {
            parent: 'model-meter',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/model-meter/model-meter-delete-dialog.html',
                    controller: 'ModelMeterDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ModelMeter', function(ModelMeter) {
                            return ModelMeter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('model-meter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
